import React, { Component } from 'react'
import { get } from 'lodash'

const withSort = (WrappedComponent) => {
  return class extends Component {
    sort = (data) => {
      if (Array.isArray(data) && data.length > 0) {
        // if (sortBy) {
        //   data = data.sort((a, b) => (a[sortBy] > b[sortBy] ? 1 : -1))
        // }
        const data0 = data[0] || {}

        if (typeof data0 === 'string' || typeof data0 === 'number') {
          data = data.sort()
        } else if (typeof data0 === 'object') {
          if (Object.keys(data0).includes('value')) {
            data = data.sort((a, b) => (a.value > b.value ? 1 : -1))
          } else if (Object.keys(data0).includes('name')) {
            data = data.sort((a, b) => (get(a, 'name') > get(b, 'name') ? 1 : -1))
          } else {
            let sortKey = Object.keys(data0)[0]
            data = data.sort((a, b) => (get(a, sortKey) > get(b, sortKey) ? 1 : -1))
          }
        }
      }
      return data
    }

    render() {
      const { data } = this.props
      const sorted = this.sort(data)
      return <WrappedComponent {...this.props} data={sorted} />
    }
  }
}

export default withSort
